import { Form, Modal, Spin } from "antd";
import { useEffect, useState } from "react";
import LinkedAccountForm from "./LinkedAccountForm";
import { useAppDispatch } from "../../../../hooks/reduxHooks";
import { linkedAccountApi } from "../../../../services/skincare.service";
import { DeleteOutlined, ExclamationCircleFilled } from "@ant-design/icons";

const { confirm } = Modal;

const LinkedAccountComponent = ({ data }: any) => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [linkedAccountMessage, setLinkedAccountMessage] = useState<
    boolean | null
  >(false);
  const [form] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onFinish = (values: any) => {
    setIsLoading(true);
    dispatch(
      linkedAccountApi({
        data: { paypal_email: values?.email },
        successCallback: (data: any) => {
          form.resetFields();
          setIsModalOpen(false);
          const status: boolean = data?.success === true;
          localStorage.setItem("linkedAccountMessage", JSON.stringify(status));
          setLinkedAccountMessage(status);
          setIsLoading(false);
        },
        finalCallback: () => {},
      })
    );
  };

  useEffect(() => {
    const storedValue = localStorage.getItem("linkedAccountMessage");
    setLinkedAccountMessage(storedValue ? JSON.parse(storedValue) : null);
  }, []);

  const showConfirm = () => {
    confirm({
      title: "Do you want to remove your account?",
      icon: <ExclamationCircleFilled />,
      centered: true,
      wrapClassName: "custom__confirm__linked__account",
      onOk() {
        localStorage.removeItem("linkedAccountMessage");
        setLinkedAccountMessage(false);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  return (
    <>
      {data ? (
        <h1
          className="payment__status__title"
          onClick={linkedAccountMessage ? showConfirm : showModal}
        >
          {linkedAccountMessage ? (
            <div
              className="remove__account"
              style={{ textTransform: "lowercase" }}
            >
              {data?.payment_info?.email}
              <DeleteOutlined />
            </div>
          ) : (
            "LINK ACCOUNT"
          )}
        </h1>
      ) : (
        <Spin />
      )}
      <Modal
        title="Linked Account"
        centered
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={false}
        wrapClassName="custom__linked__account"
      >
        <LinkedAccountForm
          onFinish={onFinish}
          form={form}
          isLoading={isLoading}
        />
      </Modal>
    </>
  );
};

export default LinkedAccountComponent;
